// extracted by mini-css-extract-plugin
export default {"label":"FormCheckbox_label__rPMiv","checked":"FormCheckbox_checked__SjFTC"};